export { default as UnidadesOrcamentarias } from "./UnidadesOrcamentarias"
export { default as UnidadesEditForm } from "./UnidadesEditForm"
export { default as UnidadesCreateForm } from "./UnidadesCreateForm"
export { default as TableUnidades } from "./TableUnidades"
export {
  default as UnidadesOrcamentariasTrash
} from "./UnidadesOrcamentariasTrash"
export { default as TableUnidadesTrash } from "./TableUnidadesTrash"



// WEBPACK FOOTER //
// ./src/views/unidades-orcamentarias/index.js